module.exports = __webpack_public_path__ + "img/img3.3ce202f0.jpg";